import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { FunctionsService } from '../../services/functions.service';
import { Consultants } from '../../models/consultants.model';
import { environment } from 'src/environments/environment';
import { ConsultantsMissions } from '../../models/consultantsMissions.model';
import { ConsultantsProduits } from '../../models/consultantsProduits.model';
import { ConsultantsExpertises } from '../../models/consultantsExpertises.model';
import { ConsultantsCountries } from '../../models/consultantsCountries.model';

@Component({
  selector: 'app-consultant-profile',
  templateUrl: './consultant-profile.component.html',
  styleUrls: ['./consultant-profile.component.scss']
})
export class ConsultantProfileComponent implements OnInit {
  consultants: Consultants = new Consultants({});
  backURL: any = '';
  missionList: any[] = [];
  produitList: any[] = [];
  expertiseList: any[] = [];
  countryList: any[] = [];

  constructor(public functionsService: FunctionsService, private router: Router) { }

  ngOnInit(): void {
    if (localStorage.getItem('profile-consultant') && localStorage.getItem('profile-consultant') != undefined) {
      const data: any = JSON.parse(localStorage.getItem("profile-consultant") || "");

      this.consultants = new Consultants(data);
      this.backURL = (localStorage.getItem('back-url') && localStorage.getItem('back-url') != undefined) ? localStorage.getItem('back-url') : 'tous-les-consultants'

      this.consultants.getConsultantsMissions().forEach(element => {
        const object = new ConsultantsMissions(element);
        this.missionList.push(object);
      });
      this.consultants.getConsultantsProduits().forEach(element => {
        const object = new ConsultantsProduits(element);
        this.produitList.push(object);
      });
      this.consultants.getConsultantsExpertises().forEach(element => {
        const object = new ConsultantsExpertises(element);
        this.expertiseList.push(object);
      });
      this.consultants.getConsultantsCountries().forEach(element => {
        const object = new ConsultantsCountries(element);
        this.countryList.push(object);
      });

    } else {
      this.router.navigate(['not-found']);
    }
  }

  formatFilePath(file_path: string): string {
    return (file_path != null && file_path != '') ? environment.apiUrl + file_path : file_path;
  }

}
